import { Stack, Typography, Chip } from "@mui/material";

import { ReactComponent as IconMinus } from "../../../../images/dialogs/minus-circle.svg";
import { ReactComponent as IconSuccess } from "../../../../images/dialogs/success.svg";
import { ReactComponent as IconError } from "../../../../images/iconError.svg";

import "../styles.css";

const listLabel = {
  empty: "Não preenchido",
  partial: "Parcialmente preenchido",
  full: "Preenchido",
};
const listIcon = {
  empty: <IconError width="24px" height="24px" />,
  partial: <IconMinus width="24px" height="24px" />,
  full: <IconSuccess width="24px" height="24px" />,
};

export default function AccordionSummaryTitle({
  title = "",
  icon = null,
  progressForm = "empty",
}) {
  return (
    <Stack flexWrap="wrap" direction="row" alignItems="center" gap="8px 24px">
      <Stack direction="row" alignItems="center" gap="8px " height="30px">
        {icon}
        <Typography className="Accordion_title">{title}</Typography>
      </Stack>
      <Chip
        sx={{
          background: "#EFF5F7",
          fontSize: "1rem",
          color: "#1E729F",
        }}
        label={listLabel[progressForm]}
        icon={listIcon[progressForm]}
      ></Chip>
    </Stack>
  );
}
